import { render } from "./OtherSettingsSection.vue?vue&type=template&id=78f177fa&scoped=true"
import script from "./OtherSettingsSection.vue?vue&type=script&lang=js"
export * from "./OtherSettingsSection.vue?vue&type=script&lang=js"

import "./OtherSettingsSection.vue?vue&type=style&index=0&id=78f177fa&scoped=true&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f177fa"]])

export default __exports__